import templateStr from 'text!./cpp-confirmation.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/components/locationsAndBuildings/directives/cpp-confirmation-directive/CPPConfirmationDirective.js
// module id = 816
// module chunks = 0